/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourcePoolProviderType } from './resourcePoolProviderType';


export interface ResourcePoolAssignSpec { 
    provider_type: ResourcePoolProviderType;
    preferred_resource_id?: string;
    /**
     * Reconfigure IRR.
     */
    reconfigure_irr?: boolean;
}
export namespace ResourcePoolAssignSpec {
}


